import { z } from "zod"

import { fieldBeforeAfterMediaV2Schema } from "./field-before-after-v2.js"
import { entityIdSchema } from "./identifiers.js"
import {
  fieldProjectionV8Schema,
  fieldVisitProjectionV8Schema,
} from "./field-projection-v8.js"

export const fieldVisitDispatchNoteV1Schema = z.object({
  noteId: entityIdSchema,
  body: z.string().trim().min(1).max(2_000),
  createdAt: z.iso.datetime({ offset: true }),
  authorDisplayName: z.string().trim().min(1).max(160),
}).strict()

export const fieldVisitProjectionV9Schema = z.object({
  ...fieldVisitProjectionV8Schema.shape,
  eventMedia: z.array(fieldBeforeAfterMediaV2Schema).max(100).default([]),
  propertyMedia: z.array(fieldBeforeAfterMediaV2Schema).max(100).default([]),
  dispatchNotes: z.array(fieldVisitDispatchNoteV1Schema).max(100).default([]),
}).strict().superRefine((visit, context) => {
  const {
    eventMedia: _eventMedia,
    propertyMedia: _propertyMedia,
    dispatchNotes: _dispatchNotes,
    ...legacy
  } = visit
  const parsed = fieldVisitProjectionV8Schema.safeParse(legacy)
  if (!parsed.success) {
    for (const issue of parsed.error.issues) {
      context.addIssue({ code: "custom", message: issue.message, path: issue.path })
    }
  }
})

export const fieldProjectionV9Schema = z.object({
  ...fieldProjectionV8Schema.shape,
  responseVersion: z.literal(9),
  visits: z.array(fieldVisitProjectionV9Schema).max(100),
}).strict().superRefine((projection, context) => {
  const candidate = {
    ...projection,
    responseVersion: 8 as const,
    visits: projection.visits.map((visit) => {
      const {
        eventMedia: _eventMedia,
        propertyMedia: _propertyMedia,
        dispatchNotes: _dispatchNotes,
        ...legacy
      } = visit
      return legacy
    }),
  }
  const parsed = fieldProjectionV8Schema.safeParse(candidate)
  if (!parsed.success) {
    for (const issue of parsed.error.issues) {
      context.addIssue({ code: "custom", message: issue.message, path: issue.path })
    }
  }
})

export type FieldProjectionV9 = z.infer<typeof fieldProjectionV9Schema>
export type FieldVisitProjectionV9 = z.infer<typeof fieldVisitProjectionV9Schema>
export type FieldVisitDispatchNoteV1 = z.infer<typeof fieldVisitDispatchNoteV1Schema>
